import React from "react";
import { formataData } from "../../../helpers/mesesHelper";
import CommonDropdown from "../../../components/dropdown/CommonDropdown";
import DropdownButton from "../../../components/dropdown/DropdownButton";
import CommonDataTable from "../../../components/Datatable/CommonDataTable";
import ButtonRounded from "../../../components/buttons/ButtonRounded";
import { AppContext } from "../../../contexts/AppContext";
import CommonButton from "../../../components/buttons/CommonButton";
import TabHelper from "../../../helpers/TabHelper";
import { FaPlus } from "react-icons/fa6";
import PropTypes from "prop-types";
import useTipos from "../../../hooks/common/useTipos";

function DocumentosColaborador({
  linhas,
  togUploadModal,
  togDocumentoModal,
  downloadDocumento,
  excluirDocumento,
  tabHook,
  editavel,
  salvaColaborador,
  retornar,
}) {
  const { session } = React.useContext(AppContext);
  const { tabAtual, setTabAtual } = tabHook;
  const tiposDocumentoColaborador = useTipos("tipos_documento_colaborador");

  const colunas = React.useMemo(
    () => [
      {
        Header: "Categoria",
        accessor: (row) => {
          return categorias[row.tipo];
        },
        isSorted: true,
        isSortedDesc: true,
      },
      {
        Header: "Descrição",
        accessor: (row) => {
          return (
            (tiposDocumentoColaborador &&
              tiposDocumentoColaborador.find(
                (tipoDocumento) =>
                  parseInt(tipoDocumento.chave) === parseInt(row.tipo)
              )?.valor) ||
            ""
          );
        },
      },
      {
        Header: "Data de upload",
        accessor: (row) => {
          const date = row.updated_at
            ? row.updated_at.split("T")
            : row.created_at.split("T");
          return formataData(date[0]);
        },
        disableSortBy: true,
      },
      {
        Header: "Ações",
        disableSortBy: true,
        Cell: ({ row }) => {
          var status = [];

          if (row.original.caminho)
            status.push(
              <>
                <DropdownButton
                  key={`visualizar-${row.original.caminho.split(".")[0]}`}
                  onClick={() => {
                    togDocumentoModal(
                      row.original.caminho.split(".")[0],
                      row.original.caminho.split(".")[1]
                    );
                  }}
                  color="primary"
                  icon="mdi mdi-file-search"
                >
                  Visualizar
                </DropdownButton>
                <DropdownButton
                  key={`download-${row.original.caminho.split(".")[0]}`}
                  onClick={() => {
                    downloadDocumento(
                      row.original.caminho.split(".")[0],
                      row.original.caminho.split(".")[1]
                    );
                  }}
                  color="success"
                  icon="mdi mdi-cloud-download"
                >
                  Download
                </DropdownButton>
              </>
            );

          if (
            parseInt(session?.codigo) === 99 ||
            [15, 16].includes(row.original.tipo)
          )
            status.push(
              <DropdownButton
                key={`excluir-${row.original.caminho.split(".")[0]}`}
                onClick={() => {
                  excluirDocumento(row.original.caminho);
                }}
                color="danger"
                icon="mdi mdi-delete"
              >
                Excluir
              </DropdownButton>
            );

          return <CommonDropdown>{status}</CommonDropdown>;
        },
      },
    ],
    [downloadDocumento, excluirDocumento, session?.codigo, tiposDocumentoColaborador, togDocumentoModal]
  );

  return (
    <>
      <div className="row">
        <div className="col mb-3">
          <CommonDataTable
            colunas={colunas}
            linhas={linhas}
            botoes={
              <ButtonRounded
                onClick={togUploadModal}
                color="success"
                icon={<FaPlus />}
              >
                Upload de documentos
              </ButtonRounded>
            }
          />
        </div>
      </div>
      <div className="row mb-3 mx-0">
        <div className="d-flex flex-column flex-md-row align-items-center justify-content-between gap-1">
          <CommonButton
            onClick={() => {
              TabHelper.trocarTab(tabAtual, setTabAtual, -1);
            }}
            color="primary"
          >
            Anterior
          </CommonButton>
          <div className="d-flex flex-column flex-md-row align-items-center gap-1">
            <CommonButton onClick={retornar} color="danger">
              Voltar
            </CommonButton>
            {editavel ? (
              <CommonButton onClick={salvaColaborador} color="success">
                Salvar
              </CommonButton>
            ) : null}
            <CommonButton
              onClick={() => {
                TabHelper.trocarTab(tabAtual, setTabAtual, 1);
              }}
              color="primary"
            >
              Próximo
            </CommonButton>
          </div>
        </div>
      </div>
    </>
  );
}

const categorias = {
  1: "Documentos pessoais",
  2: "Documentos pessoais",
  3: "Exames médicos",
  4: "Documentos pessoais",
  5: "Demissionais",
  6: "Demissionais",
  7: "Demissionais",
  8: "Demissionais",
  9: "Demissionais",
  10: "Demissionais",
  11: "Admissionais",
  12: "Admissionais",
  13: "Admissionais",
  14: "Admissionais",
  15: "Exames médicos",
  16: "Exames médicos",
};

DocumentosColaborador.propTypes = {
  linhas: PropTypes.arrayOf(PropTypes.object).isRequired,
  togUploadModal: PropTypes.func.isRequired,
  togDocumentoModal: PropTypes.func.isRequired,
  downloadDocumento: PropTypes.func.isRequired,
  excluirDocumento: PropTypes.func.isRequired,
  tabHook: PropTypes.shape({
    tabAtual: PropTypes.number.isRequired,
    setTabAtual: PropTypes.func.isRequired,
  }).isRequired,
  editavel: PropTypes.bool.isRequired,
  salvaColaborador: PropTypes.func.isRequired,
  retornar: PropTypes.func.isRequired,
  row: PropTypes.object,
};

export default DocumentosColaborador;
